module.exports = __webpack_public_path__ + "static/media/prodPerf.901f08b1.png";